import { render, staticRenderFns } from "./CoverSpiner.vue?vue&type=template&id=4247328f&"
import script from "./CoverSpiner.vue?vue&type=script&lang=js&"
export * from "./CoverSpiner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports